import { z } from "zod";
export const syncStatusSchema = z.enum([
    "LOCAL_DRAFT",
    "PENDING",
    "UPLOADING",
    "ACKNOWLEDGED",
    "RETRY_REQUIRED",
    "CONFLICT",
    "REJECTED",
]);
export const syncOperationSchema = z.object({
    operationId: z.uuid(),
    clientRecordId: z.uuid(),
    aggregateType: z.literal("HOUSEHOLD_SUBMISSION"),
    operation: z.enum(["UPSERT", "DELETE"]),
    baseVersion: z.number().int().nonnegative().nullable(),
    payloadHash: z.string().regex(/^[a-f0-9]{64}$/),
    createdAt: z.iso.datetime(),
});
export const syncPushRequestSchema = z.object({
    operation: syncOperationSchema,
    payloadSchemaVersion: z.number().int().positive().default(1),
    sourceUpdatedAt: z.iso.datetime().nullable().optional(),
    payload: z.record(z.string(), z.unknown()),
});
export const desktopAuthRequestSchema = z.object({
    username: z.string().trim().min(3).max(100),
    password: z.string().min(1).max(512),
    deviceId: z.uuid().optional(),
    deviceName: z.string().trim().min(1).max(160),
});
export const desktopRefreshRequestSchema = z.object({
    deviceId: z.uuid(),
    deviceCredential: z.string().min(32).max(512),
});
export const desktopSessionResponseSchema = z.object({
    accessToken: z.string().min(32),
    tokenType: z.literal("Bearer"),
    expiresAt: z.iso.datetime(),
    deviceId: z.uuid(),
    barangayId: z.uuid(),
});
export const desktopAuthResponseSchema = desktopSessionResponseSchema.extend({
    deviceCredential: z.string().min(32),
});
export const desktopRefreshResponseSchema = desktopSessionResponseSchema;
export const syncAcknowledgementSchema = z.object({
    operationId: z.uuid(),
    clientRecordId: z.uuid(),
    serverRecordId: z.uuid(),
    serverVersion: z.number().int().positive(),
    acknowledgedAt: z.iso.datetime(),
});
export const syncConflictSchema = z.object({
    operationId: z.uuid(),
    clientRecordId: z.uuid(),
    serverRecordId: z.uuid().nullable(),
    serverVersion: z.number().int().positive().nullable(),
    reason: z.string().min(1),
});
//# sourceMappingURL=sync.js.map